import common from './common.json';
import brightness from './brightness';
import earthlyBranch from './earthlyBranch';
import fiveElementsClass from './fiveElementsClass';
import gender from './gender';
import heavenlyStem from './heavenlyStem';
import mutagen from './mutagen';
import palace from './palace';
import star from './star';

export default {
  ...common,
  ...fiveElementsClass,
  ...heavenlyStem,
  ...earthlyBranch,
  ...brightness,
  ...mutagen,
  ...star,
  ...palace,
  ...gender,
};
